// removed by extract-text-webpack-plugin
module.exports = {"sapcnqr-screen-reader-message":"sapcnqr-screen-reader-message-d88fce"};